var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("EnviarPermiso"),
      _vm._v(" "),
      _c("AddSolicitud"),
      _vm._v(" "),
      _c("VerPermiso"),
      _vm._v(" "),
      _c("AnularPermiso"),
      _vm._v(" "),
      _c("ModificarPermiso"),
      _vm._v(" "),
      _c("AprobarPermiso"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("business")]),
          _vm._v(" Lista de servidores públicos\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-refresh",
              attrs: { slot: "activator" },
              nativeOn: {
                click: function($event) {
                  return function() {
                    _vm.filterShow = _vm.filterShow ? false : true
                  }.apply(null, arguments)
                }
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("filter_list")])],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Búsqueda/filtros")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-refresh",
              attrs: { slot: "activator" },
              nativeOn: {
                click: function($event) {
                  return _vm.cargarDatos()
                }
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("refresh")])],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("common.updateList")))])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c("transition", { attrs: { name: "slide-fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.filterShow,
                    expression: "filterShow"
                  }
                ],
                staticClass: "filter-container"
              },
              [
                _c("v-icon", { attrs: { small: "", color: "primary" } }, [
                  _vm._v("search")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Nombre", type: "text" },
                      on: { input: _vm.filternombre },
                      model: {
                        value: _vm.form.nombre,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "nombre", $$v)
                        },
                        expression: "form.nombre"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Fecha de ingreso", type: "date" },
                      on: { input: _vm.filterFechaIngreso },
                      model: {
                        value: _vm.form.fecha_ingreso,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fecha_ingreso", $$v)
                        },
                        expression: "form.fecha_ingreso"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Fecha de pasivo", type: "date" },
                      on: { input: _vm.filterFechaPasivo },
                      model: {
                        value: _vm.form.fecha_pasivo,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fecha_pasivo", $$v)
                        },
                        expression: "form.fecha_pasivo"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Item", type: "number" },
                      on: { input: _vm.filterItem },
                      model: {
                        value: _vm.form.item,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "item", $$v)
                        },
                        expression: "form.item"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Estado", type: "text" },
                      on: { input: _vm.filterActivoPasivo },
                      model: {
                        value: _vm.form.activo_pasivo,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "activo_pasivo", $$v)
                        },
                        expression: "form.activo_pasivo"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-filter" },
                  [
                    _c(
                      "v-tooltip",
                      { attrs: { bottom: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { slot: "activator", icon: "", small: "" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.recargar()
                              }
                            },
                            slot: "activator"
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("refresh")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Recargar filtros")])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tooltip",
                      { attrs: { bottom: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { slot: "activator", icon: "" },
                            nativeOn: {
                              click: function($event) {
                                return function() {
                                  _vm.filterShow = false
                                }.apply(null, arguments)
                              }
                            },
                            slot: "activator"
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("close")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Cerrar filtros")])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  items: _vm.lista_funcionarios,
                  headers: _vm.headers,
                  "disable-initial-sort": true,
                  "item-key": "id",
                  search: _vm.filters,
                  "custom-filter": _vm.customFilter,
                  loading: _vm.loading,
                  "no-data-text": "No se tiene registros",
                  "no-results-text": "No se encontraron coincidencias",
                  "rows-per-page-items": [25, 50, { text: "Todos", value: -1 }]
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.nombre))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.fecha_ingreso))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.fecha_pasivo
                                  ? items.item.fecha_pasivo
                                  : ""
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.item))
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center" },
                          [
                            _c(
                              "v-chip",
                              {
                                attrs: {
                                  color:
                                    items.item.activo_pasivo.split("|")[1] ==
                                    "Activo"
                                      ? "success"
                                      : "error",
                                  "text-color": "white"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    items.item.activo_pasivo.split("|")[1] ==
                                      "Activo"
                                      ? "Activo"
                                      : "Pasivo"
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            attrs: {
                              title:
                                "Habilitacion/Deshabilitacion de movilidades"
                            }
                          },
                          [
                            (items.item.id_estado_movilidad == 1 ||
                              items.item.id_estado_movilidad == 53) &&
                            (items.item.id_tipo_justificacion == 7 ||
                              items.item.id_tipo_justificacion == 13 ||
                              items.item.id_tipo_justificacion == 2 ||
                              items.item.id_tipo_justificacion == 1 ||
                              items.item.id_tipo_justificacion == 11)
                              ? _c("v-switch", {
                                  attrs: {
                                    value: "true",
                                    "background-color": "#DED8FF",
                                    color: "rgb(80,38,217)",
                                    label: "Habilitado"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.habilitarDeshabilitarComision(
                                        items.item,
                                        false
                                      )
                                    }
                                  },
                                  model: {
                                    value: items.item.valor_switch,
                                    callback: function($$v) {
                                      _vm.$set(items.item, "valor_switch", $$v)
                                    },
                                    expression: "items.item.valor_switch"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            items.item.id_estado_movilidad == 52 &&
                            (items.item.id_tipo_justificacion == 7 ||
                              items.item.id_tipo_justificacion == 2 ||
                              items.item.id_tipo_justificacion == 1 ||
                              items.item.id_tipo_justificacion == 13 ||
                              items.item.id_tipo_justificacion == 11)
                              ? _c("v-switch", {
                                  attrs: {
                                    value: "",
                                    "background-color": "#DED8FF",
                                    color: "colorActivo",
                                    label: "Deshabilitado",
                                    "input-value":
                                      items.item.id_estado_movilidad == 52
                                        ? true
                                        : false
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.habilitarDeshabilitarComision(
                                        items.item,
                                        true
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "success",
                                  title: "Aprobar",
                                  to:
                                    "/permisos/usuario/" + items.item.id_persona
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Ver Permisos\n            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-953a3eca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-953a3eca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/PermisoRRHH.vue
// module id = null
// module chunks = 